import React from 'react';
import {Redirect} from 'react-router-dom';
import { routePaths } from 'services/routing';

export default function ImmunizationNavigation(){
  return (
    <Redirect to={routePaths.healthObservationImmunizations} />
  );
}
